<script setup lang="ts">
import CareerContent from '~/components/molecules/CareerContent.vue';

</script>

<template>
    <CareerContent />
</template>
